import { Directive, OnInit, Inject, ElementRef, Input } from '@angular/core';
import { JQUERY_TOKEN } from '../services/JQuery.service';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[modal-trigger]',
    standalone: true
})
export class ModalTriggerDirective implements OnInit {
  private el: HTMLElement;
  @Input('modal-trigger') modalId: string;

  constructor(refEl: ElementRef, @Inject(JQUERY_TOKEN) private $: any) {
    this.el = refEl.nativeElement;
  }

  ngOnInit(): void {
    this.el.addEventListener('click', evt => {
      this.$(`#${this.modalId}`).modal('show');
    });
  }
}
